export default __webpack_public_path__ + "static/pic11-cdd9929857fd7649dd8a4d506dab4ec7.jpg";